module.exports = __webpack_public_path__ + "static/media/mars-stroke.801be55f.svg";